import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';

export const removeApplicantAutomationOverrides = (
  applicantTriggeredCommunicationId: number,
  deleteOption: 'deleteAllJobOverrides' | 'deleteOneOverride',
) =>
  createGenericDispatcher({
    name: 'REMOVE_APPLICANT_AUTOMATION_OVERRIDES',
    loadFunction: () =>
      Api.post('/applicant-automations/remove-override', {
        body: JSON.stringify({
          applicantTriggeredCommunicationId,
          [deleteOption]: true,
        }),
      }),
    args: { applicantTriggeredCommunicationId, [deleteOption]: true },
  });
